import { IGiaoVien } from "../../model/respone/category/IGiaoVien";
import { apiClient } from "../apiClient";
export const GIAO_VIEN_API = "giao-vien";
export const giaoVienApi = {
  SelectAll: () => apiClient.get(`${GIAO_VIEN_API}`),
  Insert: (payload: IGiaoVien) => apiClient.post(`${GIAO_VIEN_API}`, payload),
  Update: (payload: IGiaoVien) => apiClient.put(`${GIAO_VIEN_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${GIAO_VIEN_API}/${id}`),
};
